import "./GoogleMark.css";

export default function GoogleMark() {
  return (
    <svg
      className="google-mark"
      viewBox="0 0 18 18"
      style={{ width: 18, height: 18, flex: "0 0 18px" }}
      aria-hidden="true"
      focusable="false"
    >
      <path fill="#4285F4" d="M17.64 9.205c0-.639-.057-1.253-.164-1.841H9v3.482h4.844a4.14 4.14 0 0 1-1.796 2.716v2.258h2.909c1.702-1.566 2.683-3.873 2.683-6.615Z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.957-2.18l-2.909-2.258c-.806.54-1.837.86-3.048.86-2.343 0-4.327-1.583-5.036-3.71H.957v2.332A9 9 0 0 0 9 18Z" />
      <path fill="#FBBC05" d="M3.964 10.712A5.413 5.413 0 0 1 3.682 9c0-.595.103-1.174.282-1.712V4.956H.957A9 9 0 0 0 0 9c0 1.453.348 2.828.957 4.044l3.007-2.332Z" />
      <path fill="#EA4335" d="M9 3.578c1.321 0 2.508.454 3.441 1.345l2.581-2.58C13.462.892 11.425 0 9 0A9 9 0 0 0 .957 4.956l3.007 2.332C4.673 5.161 6.657 3.578 9 3.578Z" />
    </svg>
  );
}